import { START_LOADING, GET_OVERVIEW, STOP_LOADING, ERROR } from "../overviewReportsAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_OVERVIEW:
      return {
        ...state,
        customer_overview: action.payload,
        success: false,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}